import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '..';
import { adminBrowseResources } from './ResourcesAdminApi';

export interface IResourceFile {
  createdDate?: string;
  downloadUrl?: string;
  embedLink?: string;
  fileExtension?: string;
  id: string;
  mimeType:
    | 'application/vnd.google-apps.folder'
    | 'application/pdf'
    | 'image/jpeg';
  title: string;
  webContentLink?: string;
}

export interface IResourcesState {
  status: 'idle' | 'loading' | 'rejected';
  resourceFiles: Array<IResourceFile>;
}

const initialState: IResourcesState = {
  status: 'idle',
  resourceFiles: [],
};

export const ResourcesSlice = createSlice({
  name: 'resources',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // USER QUIZ HISTORY
      .addCase(adminBrowseResources.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(adminBrowseResources.fulfilled, (state, action) => {
        state.status = 'idle';
        state.resourceFiles = action.payload.docs || [];
      })
      .addCase(adminBrowseResources.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getResourcesState = (state: RootState): RootState['resources'] =>
  state.resources;

export * from './ResourcesAdminApi';
export default ResourcesSlice.reducer;
